import {
  Box,
  Button,
  Checkbox,
  Container,
  Divider,
  FormControlLabel,
  Typography,
} from '@mui/material';
import { useState } from 'react';
import Flex from 'src/Components/Bases/Flex/Flex';
import PoliciesContent from './Containers/PoliciesContent';

const Policies = () => {
  const [checkedTerms, setCheckedTerms] = useState(false);

  const handleCancel = () => {
    window.location.href = `${process.env.REACT_APP_SET_LINK_URL}`;
  };

  const handleNavigate = () => {
    window.location.href = '/';
  };

  return (
    <Container sx={{ height: '755', paddingY: 4 }}>
      <Typography variant="h2">
        ข้อตกลงและเงื่อนไขการใช้งานฟังก์ชัน Corporate Value Up Platform
      </Typography>
      <Flex
        flexDirection={'column'}
        p={2}
        borderRadius={2}
        boxShadow={2}
        gap={1}
        mt={2}
        bgcolor={'white'}
      >
        <PoliciesContent />
        <Divider />

        <Typography variant="subtitle2">
          หากบริษัทจดทะเบียนได้อ่านและตกลงผูกพันตามข้อตกลงและเงื่อนไขการใช้งานฟังก์ชัน
          Corporate Value Up Platform ตามที่ระบุไว้ข้างต้นนี้แล้ว โปรดเลือก
          ‘ยอมรับข้อตกลงและเงื่อนไข’ และกดยืนยันเพื่อดำเนินการต่อไป
        </Typography>

        <Flex flexDirection={'column'} alignItems={'center'}>
          <Box>
            <FormControlLabel
              control={
                <Checkbox
                  checked={checkedTerms}
                  onChange={(event) => {
                    setCheckedTerms(event.target.checked);
                  }}
                />
              }
              label={'ยอมรับข้อตกลงและเงื่อนไข'}
            />
          </Box>

          <Flex justifyContent="center" gap={2} width="100%">
            <Button
              onClick={() => {
                handleCancel();
                setCheckedTerms(false);
              }}
              color="inherit"
            >
              ยกเลิก
            </Button>
            <Button disabled={!checkedTerms} onClick={handleNavigate}>
              ยืนยัน
            </Button>
          </Flex>
        </Flex>
      </Flex>
    </Container>
  );
};

export default Policies;
